"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _default = (0, _cxs["default"])({
  " > *:not(:last-child)": {
    marginBottom: "15px"
  }
});

exports["default"] = _default;